import dayjs from 'dayjs';
import type { WordTrackChangeRevisionData } from './types';
import { Mark, mergeAttributes } from '@tiptap/core';

export const MARK_DELETE_REVISION = 'deleteRevision';

// 삭제 리비전 마크
const DeleteRevision = Mark.create({
    name: MARK_DELETE_REVISION,
    addAttributes() {
        const defaultRevision: WordTrackChangeRevisionData = {
            id: crypto.randomUUID(),
            authorInfo: {
                id: null,
                displayName: 'Unnamed',
            },
            createdAt: dayjs().toISOString(),
        };
        return {
            revision: {
                default: defaultRevision,
                parseHTML: element => JSON.parse(element.dataset.revision || 'null') || defaultRevision,
                renderHTML: attributes => {
                    return {
                        'data-revision': JSON.stringify(attributes.revision),
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-delete-revision]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { 'data-delete-revision': '' }), 0];
    },
});

export default DeleteRevision;
